import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import TechStack from "@/components/site/TechStack";
import WhyChoose from "@/components/site/WhyChoose";
import Marquee from "@/components/site/Marquee";
import Portfolio from "@/components/site/Portfolio";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[color:var(--bg)] text-white overflow-hidden relative">
      <Nav />
      <Hero />
      <TrustStrip />
      <Services />
      <TechStack />
      <Marquee />
      <WhyChoose />
      <Portfolio />
      <Process />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
